import { Box } from '@percent/lemonade'

import { SelectOptionCard } from '../../select-option-card/select-option-card'
import { OpportunityType } from '../../../dtos/opportunity.dto'
import type { OpportunityFormTypeStepProps } from './opportunity-form-type-step.types'
import styles from './opportunity-form-type-step.module.scss'

export function OpportunityFormTypeStep({
  value,
  onChange,

  eventOptionTitle,
  eventOptionDescription,
  projectOptionTitle,
  projectOptionDescription,
}: Readonly<OpportunityFormTypeStepProps>) {
  return (
    <Box className={styles.OptionsCardsBox}>
      <SelectOptionCard
        testId="eventTypeOpportunity"
        icon="volunteering-calendar"
        title={eventOptionTitle}
        description={eventOptionDescription}
        active={value === OpportunityType.Event}
        onClick={() => onChange(OpportunityType.Event)}
      />
      <SelectOptionCard
        testId="projectTypeOpportunity"
        icon="calendar-refresh"
        title={projectOptionTitle}
        description={projectOptionDescription}
        active={value === OpportunityType.Project}
        onClick={() => onChange(OpportunityType.Project)}
      />
    </Box>
  )
}
